<template>
  <div
    class="card"
    :class="[{ 'empty-outline': empty, 'no-box': noBox }, height100 ? 'h-100' : 'h-auto']"
  >
    <div
      class="card-header tw-relative"
      :class="{ '!tw-border-b-0': !showHeaderDivider }"
      v-if="!disableTitle"
    >
      <slot name="header">
        <h4
          class="header-title tw-flex tw-items-center tw-font-medium"
          :class="[{ 'tw-justify-center': titleCenter }]"
        >
          <slot name="title">
            <Logo v-if="logo" class="header-image" :logo="logo" :size="30" />
            {{ title }}
            <LearnMore v-if="help" :help="help" :testId="testId" />
          </slot>
        </h4>
        <div :class="[{ 'tw-absolute tw-right-0 tw-top-1/2 tw--translate-y-1/2': titleCenter }]">
          <slot name="header-right">
            <ActionIcons :actions="icons" :testId="testId" />
          </slot>
        </div>
      </slot>
    </div>
    <div class="card-body" :class="{ 'pad-zero': noPad }">
      <slot>{{ content }}</slot>
    </div>
  </div>
</template>

<script>
import ActionIcons from "@/components/display/ActionIcons";
import LearnMore from "@/components/display/LearnMore";
import Logo from "@/components/display/Logo";

export default {
  name: "Card",
  components: {
    ActionIcons,
    LearnMore,
    Logo,
  },
  props: {
    content: String,
    disableTitle: Boolean,
    height100: {
      type: Boolean,
      default: true,
    },
    logo: String,
    title: String,
    titleCenter: {
      type: Boolean,
      default: false,
    },
    noBox: {
      type: Boolean,
      default: false,
    },
    noPad: {
      type: Boolean,
      default: false,
    },
    icons: Array,
    help: {
      type: Object,
    },
    testId: String,
    empty: Boolean,
    showHeaderDivider: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const helpAction = (help) => {
      if (help.action) {
        help.action();
      }
    };

    const iconAction = (icon) => {
      if (icon.action) {
        icon.action();
      }
    };

    return {
      helpAction,
      iconAction,
    };
  },
};
</script>

<style lang="scss">
@import "~@/styles/variables";
.card {
  box-shadow: none !important;

  .no-box {
    padding: 0px !important;
    border: 0px !important;
  }

  .card-header {
    align-items: center;
    padding: 16px 24px 16px 24px;
    background: unset;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .header-image {
      margin-left: unset !important;
      margin-right: 10px !important;
      img {
        height: 30px;
        width: auto;
      }
    }

    .header-title {
      flex: 1;
      margin-bottom: 0;
    }

    .card-header-icon {
      cursor: pointer;
      display: inline-flex;
    }
  }

  .card-body {
    padding: 24px;
  }
}
</style>
